
/* eslint-disable */
const state = {
  accounts: [],
  account: {},
  transactions: [],
}
export default state
